import { render, staticRenderFns } from "./DropdownChild.vue?vue&type=template&id=22ccfeda&"
import script from "./DropdownChild.vue?vue&type=script&lang=js&"
export * from "./DropdownChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports